const alertConstants = {
  SUCCESS: "ALERT_SUCCESS",
  ERROR: "ALERT_ERROR",
  SECONDARY: "ALERT_SECONDARY",
  CLEAR: "ALERT_CLEAR",
};

const userConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",

  LOGOUT_REQUEST: "USERS_LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "USERS_LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "USERS_LOGOUT_FAILURE",

  LOGOUT: "USERS_LOGOUT",

  COUNTRY_REQUEST: "USERS_COUNTRY_REQUEST",
  COUNTRY_SUCCESS: "USERS_COUNTRY_SUCCESS",
  COUNTRY_FAILURE: "USERS_COUNTRY_FAILURE",

  UPDATE_PROFILE_REQUEST: "USER_UPDATE_PROFILE_REQUEST",
  UPDATE_PROFILE_SUCCESS: "USER_UPDATE_PROFILE_SUCCESS",
  UPDATE_PROFILE_FAILURE: "USER_UPDATE_PROFILE_FAILURE",

  CHANGE_PWD_REQUEST: "USER_CHANGE_PWD_REQUEST",
  CHANGE_PWD_SUCCESS: "USER_CHANGE_PWD_SUCCESS",
  CHANGE_PWD_FAILURE: "USER_CHANGE_PWD_FAILURE",

  FORGET_PWD_REQUEST: "USER_FORGET_PWD_REQUEST",
  FORGET_PWD_SUCCESS: "USER_FORGET_PWD_SUCCESS",
  FORGET_PWD_FAILURE: "USER_FORGET_PWD_FAILURE",

  RESET_PWD_REQUEST: "USER_RESET_PWD_REQUEST",
  RESET_PWD_SUCCESS: "USER_RESET_PWD_SUCCESS",
  RESET_PWD_FAILURE: "USER_RESET_PWD_FAILURE",

  TOKEN_REQUEST: "TOKEN_REQUEST",
  TOKEN_REFRESH: "TOKEN_REFRESH",
  TOKEN_VALIDITY: "TOKEN_VALIDITY",

  STATE_GUIDED_TOUR: "STATE_GUIDED_TOUR",
  INITIALIZE_GUIDED_TOUR: "INITIALIZE_GUIDED_TOUR",
};
const tickerConstants = {
  TICKER_REQUEST: "USER_TICKER_REQUEST",
  TICKER_SUCCESS: "USER_TICKER_SUCCESS",
  TICKER_FAILURE: "USER_TICKER_FAILURE",

  SET_FILTER: "SET_TICKER_FILTER",
  SET_SIDEBAR: "SET_TICKER_SIDEBAR",
};

const mapFilterConstant = {
  LOAD_MAP_REQUEST: "USER_LOAD_MAP_REQUEST",
  LOAD_MAP_SUCCESS: "USER_LOAD_MAP_SUCCESS",
  LOAD_MAP_FAILURE: "USER_LOAD_MAP_FAILURE",

  TODAY_INCIDENT_REQUEST: "USER_TODAY_INCIDENT_REQUEST",
  TODAY_INCIDENT_SUCCESS: "USER_TODAY_INCIDENT_SUCCESS",
  TODAY_INCIDENT_FAILURE: "USER_TODAY_INCIDENT_FAILURE",

  FILTER_REQUEST: "FILTER_DATA_REQUEST",
  FILTER_SUCCESS: "FILTER_DATA_SUCCESS",
  FILTER_FAILURE: "FILTER_DATA_FAILURE",

  NEXTPAGE_FILTER_REQUEST: "NEXTPAGE_FILTER_DATA_REQUEST",
  NEXTPAGE_FILTER_SUCCESS: "NEXTPAGE_FILTER_DATA_SUCCESS",
  NEXTPAGE_FILTER_FAILURE: "NEXTPAGE_FILTER_DATA_FAILURE",

  FILTER_META_REQUEST: "FILTER_META_DATA_REQUEST",
  FILTER_META_SUCCESS: "FILTER_META_DATA_SUCCESS",
  FILTER_META_FAILURE: "FILTER_META_DATA_FAILURE",

  SET_MAP_INSTANCE: "SET_WB_MAP_INSTANCE",
  SET_ZOOM_LEVEL: "SET_MAP_ZOOM_LEVEL",
  SET_FILTER: "SET_MAP_FILTER",
  SET_SIDEBAR: "SET_MAP_SIDEBAR",
  RESOLVE_ERROR: "RESOLVE_MAP_ERROR",
  CLEAR_FILTER_STATES: "CLEAR_MAP_FILTER_STATES",

  LOAD_AREAS_REQUEST: "LOAD_AREAS_DATA_REQUEST",
  LOAD_AREAS_SUCCESS: "LOAD_AREAS_DATA_SUCCESS",
  LOAD_AREAS_FAILURE: "LOAD_AREAS_DATA_FAILURE",

  MY_GEOFENCE_DATA_REQ: "MY_GEOFENCE_DATA_REQ_RESULT",
  MY_GEOFENCE_DATA_SUCCESS: "MY_GEOFENCE_DATA_SUCCESS_RESULT",
  MY_GEOFENCE_DATA_FAILURE: "MY_GEOFENCE_DATA_FAILURE_RESULT",
  // SHOW_POLYGON_REQUEST: 'EVENT_SHOW_POLYGON_REQUEST',
};

const drawingConstant = {
  DRAW_END_REQUEST: "MAP_DRAW_END_REQUEST",
  DRAW_END_UPDATE: "MAP_DRAW_END_UPDATE",
  DRAW_END_DEFAULT: "MAP_DRAW_END_DEFAULT",

  OPEN_POPUP_REQUEST: "MAP_OPEN_POPUP_REQUEST",
  OPEN_POPUP_DEFAULT: "MAP_OPEN_POPUP_DEFAULT",
  CLOSE_POPUP_REQUEST: "MAP_CLOSE_POPUP_REQUEST",
  CLOSE_POPUP_DEFAULT: "MAP_CLOSE_POPUP_DEFAULT",

  DRAWING_REQUEST: "MAP_DRAWING_REQUEST",
  DRAWING_SET_PREFERENCE: "MAP_DRAWING_SET_PREFERENCE",
  DRAWING_CHANGE_PREFERENCE: "MAP_DRAWING_CHANGE_PREFERENCE",
  DRAWING_UPDATE_PREFERENCE: "MAP_DRAWING_UPDATE_PREFERENCE",
  DRAWING_DEFAULT: "MAP_DRAWING_DEFAULT",

  SAVE_DRAWING_LAYER: "MAP_SAVE_DRAWING_LAYER",
  DELETE_DRAWING_LAYER: "MAP_DELETE_DRAWING_LAYER",

  CREATE_SHAPE_REQUEST: "CREATE_POLY_SHAPE_REQUEST",
  CREATE_SHAPE_SUCCESS: "CREATE_POLY_SHAPE_SUCCESS",
  CREATE_SHAPE_FAILURE: "CREATE_POLY_SHAPE_FAILURE",

  UPDATE_SHAPE_REQUEST: "UPDATE_POLY_SHAPE_REQUEST",
  UPDATE_SHAPE_SUCCESS: "UPDATE_POLY_SHAPE_SUCCESS",
  UPDATE_SHAPE_FAILURE: "UPDATE_POLY_SHAPE_FAILURE",

  DELETE_SHAPE_REQUEST: "DELETE_POLY_SHAPE_REQUEST",
  DELETE_SHAPE_SUCCESS: "DELETE_POLY_SHAPE_SUCCESS",
  DELETE_SHAPE_FAILURE: "DELETE_POLY_SHAPE_FAILURE",

  SAVE_DRAWING_REQUEST: "SAVE_MAP_DRAWING_REQUEST",
  SAVE_DRAWING_SUCCESS: "SAVE_MAP_DRAWING_SUCCESS",
  SAVE_DRAWING_FAILURE: "SAVE_MAP_DRAWING_FAILURE",

  LOAD_POLYGON_REQUEST: "USER_LOAD_POLYGON_REQUEST",
  LOAD_POLYGON_SUCCESS: "USER_LOAD_POLYGON_SUCCESS",
  LOAD_POLYGON_FAILURE: "USER_LOAD_POLYGON_FAILURE",
};

const mapConstants = {
  SHOW_POLYGON_REQUEST: "EVENT_SHOW_POLYGON_REQUEST",
};

export {
  alertConstants,
  drawingConstant,
  mapFilterConstant,
  tickerConstants,
  userConstants,
  mapConstants,
};
